import React from 'react';

import { Box, Typography } from '@mui/material';

import { OpenIssueCount } from '~/components/OpenIssueCount';
import { useRequest } from '~/hooks/useRequestQuery';

export const RequestInfo: React.FC = (props) => {
  const request = useRequest();
  return (
    <Box sx={{
      p: '18px 20px',
      '> p': {
        mt: '12px',
      },
      '> p:first-of-type': {
        mt: 0,
      },
    }}>
      <Typography>
        {'Build version: '}
        <Typography component="span" variant='subtitle1'>
          {request?.buildVersion || 'Not Available'}
        </Typography>
      </Typography>
      <Typography>
        {'Review Round Due: '}
        <Typography component="span" variant='subtitle1'>
          {request?.dueDate || 'Not Available'}
        </Typography>
      </Typography>
      <Typography>
        {'Round: '}
        <Typography component="span" variant='subtitle1'>
          {request?.productionRound?.value || 'Not Available'}
        </Typography>
      </Typography>
      <Typography>
        {'Open Issues: '}
        <OpenIssueCount component="span" requestId={request ? request.requestId : 'Not Available'} />
      </Typography>
      <Typography>
        {'Ticket#: '}
        <Typography component="span" variant='subtitle1'>
          {request?.requestId}
        </Typography>
      </Typography>
    </Box>
  );
}
